import { render } from "./devis.vue?vue&type=template&id=57927806&scoped=true"
import script from "./devis.vue?vue&type=script&lang=js"
export * from "./devis.vue?vue&type=script&lang=js"

import "./devis.vue?vue&type=style&index=0&id=57927806&lang=scss&scoped=true"

import exportComponent from "/usr/src/old_admin_etchite_latest_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57927806"]])

export default __exports__